import React from "react";

export default class CollectionList extends React.PureComponent {
  render() {
    const { height, children } = this.props;
    return (
      <div
        className="overflow-scroll w-full"
        style={{
          maxHeight: height
        }}
      >
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CollectionList/CollectionList.js